import { IUserCount, IUserCountResponse } from 'infrastructure/api'
import { getAPIRequest } from 'infrastructure/api'

export async function GetUserRoleCount(id: string | number, resource: string) {
  let url
  let res
  let userCount: IUserCount = {
    teacher_count: 0,
    admin_count: 0,
    student_count: 0,
  }
  if (resource.toLowerCase() === 'district') {
    url = `/v1/organizations/usercount?district_id=${id}`
  } else {
    url = `/v1/organizations/usercount?school_id=${id}`
  }
  try {
    res = await getAPIRequest<IUserCountResponse>(url)
    if (res.error === undefined && Object.keys(res).length > 0) {
      userCount = res
    }
  } catch {
    // Return default counts on network/API failure
  }

  return userCount
}
